"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorAlert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const components_1 = require("../components");
function useErrorAlert() {
    const [error, setError] = react_1.useState(null);
    return react_1.useMemo(() => {
        const alert = (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: error ? (jsx_runtime_1.jsx(components_1.Alert, Object.assign({ onDismiss: () => setError(null), title: "An error occurred" }, { children: error }), void 0)) : null }, void 0));
        return [alert, setError];
    }, [error]);
}
exports.useErrorAlert = useErrorAlert;
//# sourceMappingURL=useErrorAlert.js.map